export const getProductType = (model_type) => {
	if (model_type === 'vod') {
		return 'video';
	}

	return model_type;
};
